export * from './africaTalking.service';
import { AfricaTalkingService } from './africaTalking.service';
export * from './broadcastMessage.service';
import { BroadcastMessageService } from './broadcastMessage.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './distributionReport.service';
import { DistributionReportService } from './distributionReport.service';
export * from './feedback.service';
import { FeedbackService } from './feedback.service';
export * from './mapContentToService.service';
import { MapContentToServiceService } from './mapContentToService.service';
export * from './nitroSwitch.service';
import { NitroSwitchService } from './nitroSwitch.service';
export * from './partner.service';
import { PartnerService } from './partner.service';
export * from './relay.service';
import { RelayService } from './relay.service';
export * from './senderIdRequest.service';
import { SenderIdRequestService } from './senderIdRequest.service';
export * from './servicePlans.service';
import { ServicePlansService } from './servicePlans.service';
export * from './serviceSubscriptionContents.service';
import { ServiceSubscriptionContentsService } from './serviceSubscriptionContents.service';
export * from './smsClient.service';
import { SmsClientService } from './smsClient.service';
export * from './smsRoute.service';
import { SmsRouteService } from './smsRoute.service';
export * from './smsServiceSubscription.service';
import { SmsServiceSubscriptionService } from './smsServiceSubscription.service';
export * from './smtpSettings.service';
import { SmtpSettingsService } from './smtpSettings.service';
export * from './subActivationPerPlanservice.service';
import { SubActivationPerPlanserviceService } from './subActivationPerPlanservice.service';
export * from './subscribers.service';
import { SubscribersService } from './subscribers.service';
export * from './transactionLog.service';
import { TransactionLogService } from './transactionLog.service';
export * from './values.service';
import { ValuesService } from './values.service';
export * from './vasService.service';
import { VasServiceService } from './vasService.service';
export * from './webServiceSubscription.service';
import { WebServiceSubscriptionService } from './webServiceSubscription.service';
export const APIS = [AfricaTalkingService, BroadcastMessageService, DashboardService, DistributionReportService, FeedbackService, MapContentToServiceService, NitroSwitchService, PartnerService, RelayService, SenderIdRequestService, ServicePlansService, ServiceSubscriptionContentsService, SmsClientService, SmsRouteService, SmsServiceSubscriptionService, SmtpSettingsService, SubActivationPerPlanserviceService, SubscribersService, TransactionLogService, ValuesService, VasServiceService, WebServiceSubscriptionService];
